// extracted by mini-css-extract-plugin
export var divider = "_1a-0";
export var dividerText = "_1a-1";